import { c as _c } from "react/compiler-runtime";
import type { SkeletonProps as ChakraSkeletonProps, CircleProps } from '@chakra-ui/react';
import { Skeleton as ChakraSkeleton, Circle, Stack } from '@chakra-ui/react';
import { forwardRef } from 'react';
export interface SkeletonCircleProps extends ChakraSkeletonProps {
  size?: CircleProps['size'];
}
export const SkeletonCircle = props => {
  const $ = _c(8);
  let rest;
  let size;
  if ($[0] !== props) {
    ({
      size,
      ...rest
    } = props);
    $[0] = props;
    $[1] = rest;
    $[2] = size;
  } else {
    rest = $[1];
    size = $[2];
  }
  let t0;
  if ($[3] !== rest) {
    t0 = <ChakraSkeleton {...rest} />;
    $[3] = rest;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== size || $[6] !== t0) {
    t1 = <Circle size={size} asChild={true}>{t0}</Circle>;
    $[5] = size;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export interface SkeletonTextProps extends ChakraSkeletonProps {
  noOfLines?: number;
}
export const SkeletonText = forwardRef<HTMLDivElement, SkeletonTextProps>(function SkeletonText(props, ref) {
  const $ = _c(14);
  let gap;
  let rest;
  let t0;
  if ($[0] !== props) {
    ({
      noOfLines: t0,
      gap,
      ...rest
    } = props);
    $[0] = props;
    $[1] = gap;
    $[2] = rest;
    $[3] = t0;
  } else {
    gap = $[1];
    rest = $[2];
    t0 = $[3];
  }
  const noOfLines = t0 === undefined ? 3 : t0;
  let t1;
  if ($[4] !== noOfLines) {
    t1 = Array.from({
      length: noOfLines
    });
    $[4] = noOfLines;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== rest || $[8] !== t1) {
    t2 = t1.map((_, index) => <ChakraSkeleton height="4" key={index} {...props} _last={{
      maxW: "80%"
    }} {...rest} />);
    $[6] = props;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== gap || $[11] !== ref || $[12] !== t2) {
    t3 = <Stack gap={gap} width="full" ref={ref}>{t2}</Stack>;
    $[10] = gap;
    $[11] = ref;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});
export const Skeleton = ChakraSkeleton;